var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Card, CardHeader } from '../card';
import { Checkbox } from '../checkbox';
import { Radio, useRadioGroup } from '../radio';
import { styled } from '../styled';
import { getSelectableCardUtilityClass, selectableCardComponentName, selectableCardClasses, } from './selectable-card-classes';
import { useMergedClasses } from '../styles/classes';
import clsx from '../utils/clsx';
var Root = styled(Card, { name: selectableCardComponentName, slot: 'Root' })(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        gap: theme.spacing(2),
        alignItems: 'flex-start',
    });
});
var createControl = function (ControlComponent, slot) {
    return styled(ControlComponent, { name: selectableCardComponentName, slot: slot })(function (_a) {
        var theme = _a.theme, ownerState = _a.ownerState;
        return (__assign({ marginTop: theme.spacing(0.5), marginLeft: 0, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, alignItems: 'flex-start', marginRight: theme.spacing(0) }, (ownerState.hidden && {
            opacity: 0,
            position: 'absolute',
        })));
    });
};
var ControlRadio = createControl(Radio, 'ControlRadio');
var ControlCheckbox = createControl(Checkbox, 'ControlCheckbox');
var Content = styled('div', { name: selectableCardComponentName, slot: 'Content' })({
    flex: 1,
});
export var SelectableCard = React.forwardRef(function (props, ref) {
    var avatar = props.avatar, label = props.label, propTitle = props.title, propDescription = props.description, helperText = props.helperText, value = props.value, disabled = props.disabled, name = props.name, onChange = props.onChange, checkedProp = props.checked, RadioProps = props.RadioProps, CheckboxProps = props.CheckboxProps, _a = props.controlPlacement, controlPlacement = _a === void 0 ? 'start' : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, type = props.type, _c = props.hideControl, hideControl = _c === void 0 ? false : _c, children = props.children, className = props.className, propClasses = props.classes, rootProps = __rest(props, ["avatar", "label", "title", "description", "helperText", "value", "disabled", "name", "onChange", "checked", "RadioProps", "CheckboxProps", "controlPlacement", "size", "type", "hideControl", "children", "className", "classes"]);
    var inputRef = React.createRef();
    var radioGroup = useRadioGroup();
    var classes = useMergedClasses(selectableCardClasses, getSelectableCardUtilityClass, propClasses);
    var title = propTitle || label;
    var description = propDescription || helperText;
    var checked = checkedProp;
    if (radioGroup && checked == null) {
        checked = radioGroup.value === value;
    }
    var content = children || React.createElement(CardHeader, { avatar: avatar, title: title, subheader: description });
    var Control = type === 'radio' ? ControlRadio : ControlCheckbox;
    var control = (React.createElement(Control, __assign({ value: value, inputRef: inputRef, onChange: onChange, disabled: disabled, className: type === 'radio' ? classes.controlRadio : classes.controlCheckbox, ownerState: { hidden: hideControl }, checked: checked }, (type === 'radio' ? RadioProps : CheckboxProps))));
    return (React.createElement(Root, __assign({}, { ref: ref }, { size: size, selected: checked, disabled: disabled, button: true, className: clsx(classes.root, className), component: "label" }, rootProps),
        controlPlacement === 'start' && control,
        React.createElement(Content, null, content),
        controlPlacement === 'end' && control));
});
